import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadListProgressBarComponent } from './progress-bar.component';


@NgModule({
  declarations: [
    FileUploadListProgressBarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports:[FileUploadListProgressBarComponent],
})
export class FileUploadListProgressBarModule { }
